<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    var badge = e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge, .jdgm-prev-badge__text, .jdgm-prev-badge__stars');
    if (!badge) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    // Check if they clicked the QA badge specifically
    var isQA = e.target.closest('.jdgm-qa-badge');

    var reviewTab = document.querySelector('a[href="#tab-review"]');
    if (reviewTab) reviewTab.click();

    setTimeout(function() {
      var target = document.querySelector('#tab-review');
      if (target) target.scrollIntoView({ behavior: 'smooth' });

      if (isQA) {
        var qaTab = document.querySelector('[data-tabname="questions"]');
        if (qaTab) qaTab.click();
      }
    }, 200);
  }, true);
});
// Sync selling plan from main form to sticky form
function syncStickySellingPlan() {
  var mainForm = document.getElementById('product-form-6856604680342');
  var stickyForm = document.getElementById('product-form-sticky-6856604680342');
  if (!mainForm || !stickyForm) return;

  var mainPlan = mainForm.querySelector('input[name="selling_plan"]');
  var stickyPlan = stickyForm.querySelector('input[name="selling_plan"]');

  if (!stickyPlan) {
    stickyPlan = document.createElement('input');
    stickyPlan.type = 'hidden';
    stickyPlan.name = 'selling_plan';
    stickyForm.insertBefore(stickyPlan, stickyForm.firstChild);
  }

  stickyPlan.value = mainPlan ? mainPlan.value : '';

  var observer = new MutationObserver(function() {
    var updated = mainForm.querySelector('input[name="selling_plan"]');
    stickyPlan.value = updated ? updated.value : '';
  });
  observer.observe(mainForm, { subtree: true, attributes: true, attributeFilter: ['value'], childList: true });
}

// Wait for Kaching to finish loading before syncing
var kachingInterval = setInterval(function() {
  var mainForm = document.getElementById('product-form-6856604680342');
  if (mainForm && mainForm.querySelector('input[name="selling_plan"]')) {
    clearInterval(kachingInterval);
    syncStickySellingPlan();
  }
}, 200);